// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2U6lS","info":"PatientInfo_info__1lrR5"};